export default function findScrollableElements() {
  if (import.meta.server) return [];
  const scrollableElements = [];
  document.querySelectorAll("*").forEach((element) => {
    if (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) {
      scrollableElements.push(element);
    }
  });
  return scrollableElements;
}
